import * as HttpUtils from 'utils/HttpUtils'
import URLConst from 'constants/URLConst'
import { makeAutoObservable, runInAction } from "mobx"
import CommonConst from 'constants/CommonConst';
import FormConst from 'constants/FormConst'
import * as EzCookieUtils from 'utils/EzCookieUtils'


/*
 * Module - AuthStore.js
 *
 * Description : 사용자 인증을 
 *               관리하는 스토어 입니다. 
 * 
 * 작성자 : Choi young ho. 
 * Created on Thu Mar 04 2021
 * Copyright (c) 2021 Renewhouse corp
 */

export default class AuthStore {
	constructor(root) {
		this.root = { root };
		this.isLogin = false;
		this.lastLoginInfo = null;
		makeAutoObservable(this)
	}

	/**
	 * Cookie에 저장되어 있는 
	 * Access Token을 반환 합니다. 
	 * 
	 * 앱 실행시 자동 로그인을 위해 
	 * 기존에 로그인 정보를 확인 하는데 
	 * 사용 됩니다. 
	 * @returns 
	 */
	getAccessToken = async () => {
		let accessToken = null;
		try {
			// Cookies
			accessToken = await EzCookieUtils.getCookie(FormConst.USER_ACCESS_TOKEN);
		}
		catch (e) {
			console.log("[AuthStore/getAccessToken]" + e);
			throw e;
		}
		return accessToken;
	}

	/**
	 * 로그아웃 요청을 처리 합니다. 
	 * 
	 * Cookie정보를 삭제 하고 
	 * 
	 * UserStore의 userInfo 정보를 
	 * 초기화 합니다. 
	 */
	reqLogout = async () => {
		try {
			// 쿠키 정보를 초기화 합니다. 
			// await CookieManager.clearAll();
			// 사용자 정보를 초기화 합니다. 
			this.root.userStore.setUserInfo(null);
			// 회사 정보를 초기화 합니다. 
			this.root.companyStore.setCompanyInfo(null);
			// 최근 로그인 정보를 초기화 합니다. 
			this.initLastLoginInfo();
		}
		catch (e) {
			throw e;
		}
	}

	/**
	 * 사용자 로그인 상태를 
	 * 설정 합니다. 
	 * @param {*} loginState 
	 */
	setLoginState = (loginState) => {
		this.isLogin = loginState;
	}

	// /**
	//  * 아이디 중복을 체크 합니다. 
	//  * @param {*} ezComapnyId 
	//  */
	// doCheckId = async (ezComapnyId) => {
	// 	try {
	// 		let param = {};
	// 		param[FormConst.ADMIN_ID] = ezComapnyId;
	// 		let result = await HttpUtils.doPostFormData(URLConst.MEMBER_ID_SEARCH_URL, param);
	// 		return result;
	// 	}
	// 	catch (e) {
	// 		throw e;
	// 	}
	// }

	/**
	 * AsynStorage에서 
	 * 최근 로그인 정보를 
	 * 반환 합니다. 
	 */
	getLastLoginInfo = async () => {
		let obj = {};
		try {
			obj[FormConst.ADMIN_ID] = await EzCookieUtils.getCookie(FormConst.ADMIN_ID);
			obj[FormConst.USER_PW] = await EzCookieUtils.getCookie(FormConst.USER_PW);

			console.log("user Obj", obj);

		} catch (e) {
			throw e;
		}
		return obj;
	}

	/**
	 * 최근 로그인 정보를 
	 * EzCookieUtils에 저장 합니다. 
	 * @param {*} ezComapnyId 
	 * @param {*} userPw 
	 * @param {*} userId 
	 */
	// setLastLoginInfo = async (ezComapnyId, userPw, userId = null) => {
	// 	try {
	// 		runInAction(() => {
	// 			EzCookieUtils.setItem(FormConst.ADMIN_ID, ezComapnyId);
	// 			EzCookieUtils.setItem(FormConst.USER_PW, userPw);
	// 			if (userId)
	// 				EzCookieUtils.setItem(FormConst.USER_ID, userId);
	// 		});


	// 		this.lastLoginInfo = {};
	// 		this.lastLoginInfo[FormConst.ADMIN_ID] = ezComapnyId;
	// 		this.lastLoginInfo[FormConst.USER_PW] = userPw;
	// 		if (userId)
	// 			this.lastLoginInfo[FormConst.USER_ID] = userId;

	// 		console.log("[AuthStore/setLastLoginInfo] Store ok...");
	// 	} catch (e) {
	// 		throw e;
	// 	}
	// }

	/**
	 * 최근 로그인 정보를 
	 * 초기화 합니다. 
	 */
	// initLastLoginInfo = async () => {
	// 	try {
	// 		runInAction(() => {
	// 			EzCookieUtils.removeItem(FormConst.ADMIN_ID);
	// 			EzCookieUtils.removeItem(FormConst.USER_PW);
	// 			EzCookieUtils.removeItem(FormConst.USER_ID);
	// 			this.lastLoginInfo = {};
	// 		});
	// 	} catch (e) {
	// 		throw e;
	// 	}
	// }


	/**
	  * 서버에 로그인을 
	 * 요청 합니다. 
	 * 
	 * 로그인이 성공한 경우에 한하여 
	 * 사용자 프로필 갱신을 요청 합니다. 
	 * 
	 * 로그인 상태는 사용자 
	 * 프로필이 정상적으로 
	 * 갱신된 후에 변경 됩니다. 
	 * @param {*} ezCompanyId 
	 * @param {*} userPw 
	 * @param {*} userId 
	 * @returns 
	 */
	reqLogin = async ({
		ezCompanyId,
		loginMode,
		userPw
	}) => {
		try {
			let param = {};
			param[FormConst.ADMIN_ID] = ezCompanyId;

			if (loginMode)
				param[FormConst.LOGIN_MODE] = CommonConst.LOGIN_MODE_PERMARNENT;
			else
				param[FormConst.LOGIN_MODE] = CommonConst.OPTION_FALSE;

			param[FormConst.USER_PW] = userPw;

			// 영구 로그인 모드로 설정 합니다. 
			param[FormConst.LOGIN_MODE] = CommonConst.LOGIN_MODE_PERMARNENT;
			let result = await HttpUtils.doPostFormData(URLConst.ADMIN_LOGIN_REQ_JSON, param);
			// 로그인 상태를 변경 합니다. 
			if (result[FormConst.ERROR_MSG] === '') {
				runInAction(() => {
					console.log("============================= Login OK");
					this.isLogin = true;
				});
			}

			return result;
		}
		catch (e) {
			throw e;
		}
	}

	// /**
	//  * 회원 가입을 요청 합니다. 
	//  * @param {*} joinValues 
	//  * @returns 
	//  */
	// reqJoin = async ({
	// 	ezComapnyId,
	// 	userPw,
	// 	compName,
	// 	ceoName,
	// 	ageLimitAccept,
	// 	privateInfoAccept,
	// 	serviceAccept,
	// 	marketingAccept
	// }) => {
	// 	try {
	// 		let param = {};
	// 		param[FormConst.ADMIN_ID] = ezComapnyId;                         // Mall ID
	// 		param[FormConst.USER_PW] = userPw;                                    // 비밀번호 
	// 		param[FormConst.USER_COMP_NAME] = compName;                           // 회사
	// 		param[FormConst.USER_CEO_NAME] = ceoName;                             // 대표자명 
	// 		param[FormConst.USER_POLICY_AGE_LIMIT_ACCEPT] = ageLimitAccept;      // 만 14세 이상 확인 
	// 		param[FormConst.USER_POLICY_PRIVATE_INFO_ACCEPT] = privateInfoAccept; // 개인정보 이용 약관
	// 		param[FormConst.USER_POLICY_SERVICE_ACCEPT] = serviceAccept;          // 서비스 이용 약관 
	// 		param[FormConst.USER_POLICY_MARKETING_ACCEPT] = marketingAccept;      // 마케팅 활용 약관 

	// 		let result = await HttpUtils.doPostFormData(URLConst.MEMBER_INSERT_DATA_URL, param);
	// 		if (result[FormConst.ERROR_MSG] == '') {
	// 			this.currentUser = result[FormConst.OBJECT_FIELD];
	// 			// 최근 로그인 정보를 수정 합니다. 
	// 			this.setLastLoginInfo(ezComapnyId, userPw);
	// 		}
	// 		return result;
	// 	}
	// 	catch (e) {
	// 		throw e;
	// 	}
	// }

	// /**
	//  * 아이디 찾기 요청을 
	//  * 처리 합니다. 
	//  */
	// reqFindId = async (
	// 	compName,
	// 	ceoName,
	// 	compSsn,
	// ) => {
	// 	try {
	// 		let param = {};

	// 		param[FormConst.USER_COMP_NAME] = compName;     // 상호
	// 		param[FormConst.USER_CEO_NAME] = ceoName;       // 대표자 성명
	// 		param[FormConst.USER_COMP_SN] = compSsn;        // 사업자 등록 번호

	// 		let result = await HttpUtils.doPostFormData(URLConst.COMPANY_FIND_ADMIN_ID_URL, param);
	// 		// if (result[FormConst.ERROR_MSG] == '') {
	// 		//   const rows = result[FormConst.LIST_FIELD];
	// 		// }
	// 		return result;
	// 	}
	// 	catch (e) {
	// 		throw e;
	// 	}
	// }

	// /**
	//  * 임시 비밀번호 
	//  * 발급을 요청 합니다. 
	//  */
	// reqPasswordReset = async (
	// 	compName,
	// 	ceoName,
	// 	ezCompanyId,
	// ) => {
	// 	try {
	// 		let param = {};

	// 		param[FormConst.USER_COMP_NAME] = compName;     // 상호
	// 		param[FormConst.USER_CEO_NAME] = ceoName;       // 대표자 성명
	// 		param[FormConst.ADMIN_ID] = ezCompanyId;   // 몰 ID

	// 		let result = await HttpUtils.doPostFormData(URLConst.COMPANY_FIND_EZ_COMPANY_PW_URL, param);
	// 		return result;
	// 	}
	// 	catch (e) {
	// 		throw e;
	// 	}
	// }
}